<template>
  <header
    :class="[
      'header',
      { 'header--small': small },
      { 'header--no-shadow': noShadow }
    ]"
  >
    <div
      v-if="!$slots['default']"
      class="header__items"
    >
      <section
        v-if="$slots['header-left']"
        class="header__left"
      >
        <slot name="header-left" />
      </section>

      <section v-if="$slots['header-center']">
        <slot name="header-center" />
      </section>
      <h4 v-else>
        {{ title }}
      </h4>

      <section
        v-if="$slots['header-right']"
        class="header__right"
      >
        <slot name="header-right" />
      </section>
    </div>

    <slot />
  </header>
</template>

<script>
export default {
  name: 'Header',

  props: {
    title: {
      type: String,
      default: 'Digital Foamboard'
    },
    small: {
      type: Boolean,
      default: false
    },
    noShadow: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  @include size(100%, $height-header);

  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: $white;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  &.header--small {
    height: $height-header-small;
  }

  &.header--no-shadow {
    box-shadow: none;
  }
}

.header__items {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header__left,
.header__right {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: auto;
  color: $blue;

  > * {
    color: $blue;
    border-radius: $border-radius-default;
  }
}

.header__left {
  left: 0;

  > * {
    margin-right: $spacer-unit;
  }
}

.header__right {
  right: 0;

  > * {
    margin-left: $spacer-unit-x2;
  }
}
</style>
